import { CommunityId } from '../model/community.types';

// Apollo serialises a field's args into its storeFieldName, e.g.
// blockedUsers({"communityId":7}). Use this to act on only the cached variant
// scoped to a given community instead of matching the raw string ad hoc.
export const matchesCommunityArg = (
  storeFieldName: string,
  communityId: CommunityId,
): boolean => storeFieldName.includes(`"communityId":${communityId}`);
